import { RequestStatus } from "@albertine/types";

// Re-export for backward compatibility
export { RequestStatus };

export const RequestStatusList = RequestStatus.options;

export const RequestStatusMap: Record<RequestStatus, string> = {
    new: "New",
    draft: "Draft",
    open: "Open",
    confirmed: "Confirmed",
    closed: "Closed",
};

export const RequestStatusToTimestampMap: Record<RequestStatus, string | undefined> = {
    new: undefined,
    draft: undefined,
    open: "openedAt",
    confirmed: "confirmedAt",
    closed: "closedAt",
};
